import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser'
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalConfig } from './modal-config';

@Component({
  selector: 'modal-component',
  templateUrl: './modal.component.html',
  styleUrls: [ './modal.component.css' ]
})
export class ModalComponent {

  @ViewChild('modalComponent') public readonly modal: ModalDirective;
  @Output('accept') public onAccept = new EventEmitter<any>();
  @Output('reject') public onReject = new EventEmitter<any>();
  @Input('data') public templateConfig: ModalConfig;
  @Input() public title: string;
  @Input() public content: SafeHtml;
  public config: ModalConfig = {
    backdrop: 'static',
    keyboard: false,
    focus: false,
    show: false,
    ignoreBackdropClick: true,
    small: false,
    resizeOrClose:'resize',
    okBtnTitle: 'Ok',
    okBtnAutoHide: true,
    okBtnCssClass: '',
    cancelBtnTitle: 'Cancel',
    cancelBtnAutoHide: true,
    cancelBtnCssClass: ''
  };
  public payload: any;


  public accept(): void {
    this.onAccept.emit(this.payload);
    if(this.config.okBtnAutoHide==true){
      this.modal.hide();
    }
  }


  public reject(): void {
    this.onReject.emit(this.payload);
    if(this.config.cancelBtnAutoHide==true){
      this.modal.hide();
    }
  }


  // Optional method for setting the button text.  Can also be set in the
  // <modal-component> in the html file.  Note that setting it in the html
  // file causes this function to become inoperative.
  public cancelButtonTitle(title: string) {
      this.config.cancelBtnTitle = title;
  }


  public open(config?: ModalConfig, payload ?: any): void {
    this._init(config, payload);
    this.modal.show();
  }
  public close(config?: ModalConfig, payload ?: any): void {
    this._init(config, payload);
    this.modal.hide();
  }

  public closeNow(config?: ModalConfig, payload ?: any): void {
    this.modal.hide();
  }



  private resize(): void {
    this.config.small = !this.config.small;
  }


  public  _init(modalConfig: ModalConfig, payload: any): void {
    let config = Object.assign(this.config, this.templateConfig, modalConfig);
    this.config = config;
    this.modal.config = config;
    this.payload = payload || null;
  }
}
